//
// Module for the Detail view (Fund and Participant Workflow Detail pages)
//
rs.module("framework/content/workflow/detail",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, backendUrls, variables, jsSelectors) {

            var workflowDetailsForm = $.js(jsSelectors.workflowDetailsForm);
            var workflowDetailsContainer = workflowDetailsForm.js(jsSelectors.workflowDetailsContainer);
            var workflowDetailsSaveButton = workflowDetailsForm.js(jsSelectors.workflowDetailsSaveButton);
            var workflowDetailsCancelButton = workflowDetailsForm.js(jsSelectors.workflowDetailsCancelButton);

            // If any current workflow steps are in Processing status, setup a timer to run in 5 seconds to check for updates 
            if (lrsGridApi && lrsGridApi.agGridApi.pg.gridOptions.context.isProcessing) {
                _setupTimer();
            }  

            //
            // Setup timer for delayed Current Steps grid refresh
            //
            function _setupTimer() {
                setTimeout(updateCurrentStepsGrid, 5000);
            }

            //
            // Refresh the Current Steps grid
            //
            function updateCurrentStepsGrid() {

                gridModule.update(
                    backendUrls.getWorkflowCurrentStepsGrid,
                    {
                        workflowInstanceId: variables.workflowInstanceId,
                        workflowSubjectKey: variables.workflowSubjectKey,
                        workflowSubjectType: variables.workflowSubjectType
                    },
                    lrsGridApi.agGridApi,
                    function done(gridUpdate) {

                        // If any current workflow steps are still in Processing status, setup a new timer to run in 5 seconds to check again for updates 
                        if (gridUpdate.context.isProcessing) {
                            _setupTimer();
                        }
                        // Once the current steps have been updated, also update the Workflow Details card if the workflow has become cancelled or completed
                        else if (gridUpdate.context.isWorkflowCancelledOrCompleted) { 
                            $.get(backendUrls.getWorkflowDetailsContainer, { workflowInstanceId: variables.workflowInstanceId },
                                function (html) {
                                    workflowDetailsContainer.html(html);
                                    workflowDetailsSaveButton.setDisabled();
                                    workflowDetailsCancelButton.setDisabled();
                                });
                        }
                    }
                );
            }            
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);